/**
 * 기획전 띠의 바깥 틀(모서리·테두리·안쪽 여백) — 띠와 이름을 기다리는 회색 칸이 함께 써서
 * 이름이 도착해 띠로 바뀌어도 크기가 같아 아래 목록이 밀리지 않게 한다.
 */
export const STORE_EXHIBITION_BANNER_FRAME = 'rounded-md border px-4 py-3';
